var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavadogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 970,
    height: 150,
    viewBox: "0 0 970 150",
    style: {
      maxWidth: "100%",
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(75,75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#883333"
  }), /*#__PURE__*/React.createElement("path", {
    className: "letter",
    "data-letter": "s",
    d: "M 53.03300858899105 -53.03300858899107 A 75 75 0 0 0 -75 9.184850993605149e-15 L -75 7 L 61 7 A 61 61 0 0 1 -43.13351365237939 43.1335136523794 L -53.03300858899106 53.033008588991066 A 75 75 0 0 0 75 0 L 75 -7 L -61 -7 A 61 61 0 0 1  43.133513652379385 -43.133513652379406 Z ",
    fill: "#ff0000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.5 -7.5 A 40 40 0 0 1 39.5 -7.5 Z",
    stroke: "none",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.5 7.5 A 40 40 0 0 0 39.5 7.5 Z",
    stroke: "none",
    fill: "#ffffff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(239,75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#883333"
  }), /*#__PURE__*/React.createElement("path", {
    "data-letter": "a1",
    d: " M -75 75 L -75 0 A 75 75 0 0 1 -7 -74.67261881037788 L -7 75 L -21 75 L -21 7 L -61 7 L -61 75 Z M -21 -7 L -21 -57.271284253105414 A 61 61 0 0 0 -60.597029630172464 -7 Z  ",
    fill: "#ff0000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 7 -75 L 21 -75 L 21 57.271284253105414 A 61 61 0 0 0 61 0 L 61 -75 L 75 -75 L 75 0 A 75 75 0 0 1 7 74.67261881037788 Z  ",
    fill: "#ff0000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.5 -7.5 A 40 40 0 0 1 -21.5 -34 L -21.5 -7.5 Z",
    stroke: "none",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.5 7.5 A 40 40 0 0 0 -21.5 34 L -21.5 7.5 Z",
    stroke: "none",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -7 -39 A 40 40 0 0 1 7 -39 L 7 39 A 40 40 0 0 1 -7 39 Z",
    stroke: "none",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.5 -34 A 40 40 0 0 1 21.5 34 Z",
    stroke: "none",
    fill: "#ffffff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(403,75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#883333"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -75 75 L -75 0 A 75 75 0 0 1 -7 -74.67261881037788 L -7 75 L -21 75 L -21 7 L -61 7 L -61 75 Z M -21 -7 L -21 -57.271284253105414 A 61 61 0 0 0 -60.597029630172464 -7 Z  ",
    fill: "#ff0000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 7 -75 A 75 75 0 0 1 7 74.67261881037788 Z M 21 57.271284253105414 A 61 61 0 0 0 21 -57.271284253105414 Z  ",
    stroke: "none",
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.5 -7.5 A 40 40 0 0 1 -21.5 -34 L -21.5 -7.5 Z",
    stroke: "none",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -39.5 7.5 A 40 40 0 0 0 -21.5 34 L -21.5 7.5 Z",
    stroke: "none",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -7 -39 A 40 40 0 0 1 7 -39 L 7 39 A 40 40 0 0 1 -7 39 Z",
    stroke: "none",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.5 -34 A 40 40 0 0 1 21.5 34 Z",
    stroke: "none",
    fill: "#ffffff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(567,75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#883333"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 0 -75  A 75 75 0 0 0 0 75  A 75 75 0 0 0 0 -75  Z M 0 -61  A 61 61 0 0 1 0 61  A 61 61 0 0 1 0 -61  Z   ",
    stroke: "none",
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#ffffff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(731,75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#883333"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 53.03300858899105 -53.03300858899107 A 75 75 0 1 0 74.67261881037788 -7 L 0 -7 L 0 7 L 60.597029630172464 7 A 61 61 0 1 1 43.133513652379385 -43.133513652379406 Z ",
    stroke: "none",
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 39 7.5 L 0 7.5 L 0 -7.5 L 39 -7.5 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#ffffff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(895,75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#883333"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 0 -75  A 75 75 0 0 0 0 75  A 75 75 0 0 0 0 -75  Z M 0 -61  A 61 61 0 0 1 0 61  A 61 61 0 0 1 0 -61  Z   ",
    stroke: "none",
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 -40 A 40 40 0 0 0 0 40 A 40 40 0 0 0 0 -40 Z",
    stroke: "none",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavadogo);
export default __webpack_public_path__ + "static/media/savadogo.76a0fb0089f1c44ecc484acea32609c0.svg";
export { ForwardRef as ReactComponent };